import { ActivityModel, type ActivityResponse, type NetworkActivity } from '@/models/activity';
import { signedApiClient } from '@/services/apiClient';

class ActivityService {

  private investigationEndpoint: string = '';

  initService(investigationEndpoint: string) {
    this.investigationEndpoint = investigationEndpoint;
  }

  async getActivityActions(studyIdentifier: string, limit: number, page: number) {
    let uri = `${this.investigationEndpoint}/${studyIdentifier}/activity?limit=${limit}`;

    if (page > -1) {
      uri += `&page=${page}`;
    }

    const apiClient = signedApiClient('GET', uri);
    const activityResponse = await apiClient.get(uri);

    const activityCount = activityResponse.data.activitiesCount;
    const networkActivity: NetworkActivity[] = activityResponse.data.activities;
    const formattedActivity: ActivityResponse = {
      activities: networkActivity.map(activityItem => ActivityModel.mapFromBackend(activityItem)),
      activityCount: activityCount
    };
    return formattedActivity;
  }
}

export default new ActivityService();
